import type {
  Args as _Args,
  GeneratedDatabaseSchema as _GeneratedDatabaseSchema,
  PostgresAdapter as _PostgresAdapter,
} from '../types.js'

/**
 * @deprecated - import from `@payloadcms/db-postgres` instead
 */
export type Args = _Args

/**
 * @deprecated - import from `@payloadcms/db-postgres` instead
 */
export type GeneratedDatabaseSchema = _GeneratedDatabaseSchema

/**
 * @deprecated - import from `@payloadcms/db-postgres` instead
 */
export type PostgresAdapter = _PostgresAdapter
